// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Chamados_FranquiasResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Chamados_FranquiasResponse — GET /chamados/franquias.
 *
 * As franquias para as quais ESTE usuário pode abrir chamado, para o seletor do
 * formulário.
 *
 * POR QUE ESTE ENDPOINT EXISTE, e por que não dá para reaproveitar o seletor
 * de franquia que o resto do sistema usa: o resto do sistema oferece as
 * franquias do FILTRO, que são as LIBERADAS POR BILLING. Aqui a lista tem de
 * ser a da IDENTIDADE — senão a franquia inadimplente abre a tela de chamado e
 * encontra um seletor VAZIO, sem conseguir pedir ajuda exatamente no dia em que
 * mais precisa ("meu sistema travou, não consigo faturar").
 *
 * É a mesma decisão do `abrir()`, exposta na leitura: se as duas pontas não
 * usassem a mesma fonte, a tela ofereceria uma opção que o POST recusaria, ou
 * esconderia uma que ele aceitaria.
 */
import type { Chamados_FranquiaRow } from './Chamados_FranquiaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Chamados_FranquiasResponseDados {
rows: Chamados_FranquiaRow[]
}

export type Chamados_FranquiasResponse = ApiResponse<Chamados_FranquiasResponseDados>;

registerResponseContract('Chamados_FranquiasResponse', {
  rows: {
    type: 'array',
    required: true,
    items: {
      id:   { type: 'number',  required: true },
      nome: { type: 'string',  required: false },
    },
  },
})
